import { createActionGroup, emptyProps, props } from '@ngrx/store';

/** Which info panel the Plan page's side drawer shows for Monthly Outlook. */
export type PaceInfoView = 'pace' | 'trends';

export const PaceActions = createActionGroup({
  source: 'Pace',
  events: {
    // A6-style UI-orchestration command: the Monthly Outlook empty state's
    // "Connect an Account" opens the accounts feature's modal, and the plan
    // feature must not import across the feature boundary — the effect
    // resolves the service through a dynamic import instead.
    'Connect Account': emptyProps(),

    // The "i" panels open in the Plan page's side drawer (same drawer as the
    // double-count info), driven through the store like the leftover selection.
    'Show Pace Info': props<{ view: PaceInfoView | null }>(),

    // The day-details drawer: a chart touch opens it on that day, the chips
    // and the Today button re-target it, null closes it.
    'Show Pace Details': props<{ day: number | null }>(),
  },
});
